import { CSSProperties } from 'react';

import { theme } from 'coreOld/themes';

export const optionStyle: CSSProperties = {
  border: `1px solid ${theme.palette.backgrounds.border}`,
  borderTop: 'none',
  cursor: 'pointer',
  letterSpacing: -0.6,
  fontWeight: 300,
  textAlign: 'left',
};

export const menuListStyle: CSSProperties = {
  maxHeight: 374,
};
